import { render } from "./PhiDichVuVer2.vue?vue&type=template&id=f8372a7a&scoped=true"
const script = {}

import "./PhiDichVuVer2.vue?vue&type=style&index=0&id=f8372a7a&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8372a7a"]])

export default __exports__